<template>
  <div>
    <!-- 导航 -->
    <el-breadcrumb>
      <el-breadcrumb-item>
        <router-link to="./">首页</router-link>
      </el-breadcrumb-item>
      <el-breadcrumb-item>产品管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 主体内容 -->
    <div class="content">
      <el-form
        inline
        label-position="right"
        label-width="60px"
        size="small"
        class="query-form"
      >
        <el-form-item label="搜索">
          <el-cascader
            :show-all-levels="false"
            :options="cascaderType"
            placeholder="产品类型"
            clearable
            @change="changeCascader"
          >
          </el-cascader>
        </el-form-item>
        <el-form-item style="margin-left: 6px" label="">
          <el-input
            v-model="query.key"
            placeholder="请输入关键词"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="selList()">查询</el-button>
          <el-button
            type="success"
            @click="
              dialogVisible = true;
              form = { isEnable: true };
            "
            >新增</el-button
          >
        </el-form-item>
      </el-form>
      <!-- 列表查询 -->
      <el-card class="box-card table">
        <div slot="header" class="clearfix">
          <span>产品列表</span>
        </div>
        <!-- 列表定义 -->
        <el-table
          v-loading="loading"
          :data="tableData"
          ref="tableData"
          border
          stripe
          style="width: 100%"
        >
          <el-table-column
            label="名称"
            prop="name"
            width="280"
            fixed
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <a
                :href="
                  domainFront +
                  '/product' +
                  scope.row.productType.productTypeParent.id +
                  '/' +
                  scope.row.typeID +
                  '/' +
                  scope.row.id +
                  '.html'
                "
                target="_blank"
                class="el-link el-link--default is-underline"
              >
                <span>{{ scope.row.name }}</span>
              </a>
            </template>
          </el-table-column>
          <el-table-column
            prop="productType.name"
            label="产品类型"
            align="center"
            width="240"
            :show-overflow-tooltip="true"
          >
            <template slot-scope="scope">
              <a
                :href="
                  domainFront +
                  '/product' +
                  scope.row.productType.productTypeParent.id +
                  '/' +
                  scope.row.productType.id +
                  '.html'
                "
                target="_blank"
                class="el-link el-link--default is-underline"
              >
                <span>{{ scope.row.productType.name }}</span>
              </a>
            </template>
          </el-table-column>
          <el-table-column
            label="推荐首页"
            prop="isRecommend"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isRecommend"
                :active-value="true"
                :inactive-value="false"
                @change="changeRecommend(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            label="是否隐藏"
            prop="isHidden"
            width="150"
            align="center"
          >
            <template slot-scope="scope">
              <el-switch
                v-model="scope.row.isHidden"
                :active-value="true"
                :inactive-value="false"
                @change="changeHidden(scope.row)"
              >
              </el-switch>
            </template>
          </el-table-column>
          <el-table-column
            prop="seq"
            label="排序"
            sortable
            align="center"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="editor.realName"
            label="编辑人"
            align="center"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="editTime"
            label="编辑时间"
            sortable
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            prop="creater.realName"
            label="创建人"
            align="center"
            width="140"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="创建时间"
            sortable
            align="center"
            width="200"
          ></el-table-column>
          <el-table-column
            label="操作"
            align="center"
            fixed="right"
            width="230"
          >
            <template slot-scope="scope">
              <el-tooltip content="产品图集" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-picture-outline"
                  @click="openChildDialog(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="编辑" placement="top">
                <el-button
                  type="primary"
                  size="mini"
                  icon="el-icon-edit"
                  @click="editClick(scope.row)"
                ></el-button>
              </el-tooltip>
              <el-tooltip content="删除" placement="top">
                <el-button
                  type="warning"
                  size="mini"
                  icon="el-icon-delete"
                  @click="delClick(scope.row)"
                ></el-button>
              </el-tooltip>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页条 -->
        <div class="block" style="margin-top: 20px">
          <el-pagination
            background
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage4"
            :page-sizes="[10, 20, 30, 50, 100]"
            :page-size="pageSize"
            layout="total, sizes,prev, pager, next, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </el-card>
    </div>

    <!-- 操作对话框 -->
    <el-dialog
      :title="form.id > 0 ? '编辑产品' : '添加产品'"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        ref="form"
        label-width="116px"
        :status-icon="true"
        @submit.native.prevent="submitForm('form')"
      >
        <el-form-item
          label="产品名称"
          prop="name"
          :rules="[
            {
              required: true,
              message: '请输入产品名称',
            },
          ]"
        >
          <el-input
            v-model.trim="form.name"
            placeholder="请输入产品名称"
            @blur="checkExist($event)"
          ></el-input>
        </el-form-item>

        <el-form-item
          label="产品类型"
          prop="typeCascader"
          :rules="[{ required: true, message: '请选择产品大类' }]"
        >
          <el-cascader
            v-model="cascader"
            :show-all-levels="false"
            :options="cascaderType"
            placeholder="产品类型"
            clearable
            @change="handleType"
          >
          </el-cascader>
        </el-form-item>

        <el-form-item
          label="SEO标题"
          prop="seoTitle"
          :rules="[{ required: true, message: '请输入SEO标题' }]"
        >
          <el-input
            v-model="form.seoTitle"
            placeholder="请输入SEO标题"
            maxlength="150"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item
          label="SEO关键词"
          prop="seoKeywords"
          :rules="[{ required: true, message: '请输入SEO关键词' }]"
        >
          <el-input
            v-model="form.seoKeywords"
            placeholder="请输入SEO关键词"
            maxlength="150"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item
          label="SEO描述"
          prop="seoDescription"
          :rules="[{ required: true, message: '请输入SEO描述' }]"
        >
          <el-input
            type="textarea"
            :autosize="{ minRows: 4, maxRows: 8 }"
            v-model="form.seoDescription"
            placeholder="请输入SEO描述"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>

        <el-form-item
          label="排序数字"
          prop="seq"
          :rules="[{ type: 'number', message: '请填写数字' }]"
        >
          <el-input
            v-model.number="form.seq"
            placeholder="请输入排序数字"
          ></el-input>
        </el-form-item>

        <el-form-item label="产品说明" prop="description">
          <div style="position: relative">
            <vue-ueditor-wrap
              v-model="form.description"
              :config="editorConfig"
            ></vue-ueditor-wrap>
          </div>
        </el-form-item>

        <el-form-item label="规格型号" prop="specificationModel">
          <div style="position: relative">
            <vue-ueditor-wrap
              v-model="form.specificationModel"
              :config="editorConfig2"
            ></vue-ueditor-wrap>
          </div>
        </el-form-item>

        <!-- <el-form-item label="是否隐藏" prop="isHidden">
          <el-switch
            v-model="form.isHidden"
            :active-value="true"
            :inactive-value="false"
            active-text="是"
          >
          </el-switch>
        </el-form-item> -->
        <el-form-item label="其他设置" prop="content">
          <el-switch
            v-model="form.isRecommend"
            :active-value="true"
            :inactive-value="false"
            active-text="推荐首页"
            style="margin-left: 25px"
          >
          </el-switch>
          <el-switch
            v-model="form.isHidden"
            :active-value="true"
            :inactive-value="false"
            active-text="是否隐藏"
            style="margin-left: 25px"
          >
          </el-switch>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" :loading="submiting" native-type="submit"
            >提交</el-button
          >
          <el-button @click="(dialogVisible = false), resetForm('form')"
            >取消</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>

    <!-- 产品图片 -->
    <el-dialog
      :title="'产品图集-' + productName"
      :visible.sync="dialogImage"
      :fullscreen="true"
    >
      <pro-image-item :deliverProID="productID"></pro-image-item>
    </el-dialog>
  </div>
</template>

<script>
import VueUeditorWrap from "vue-ueditor-wrap"; // ES6 Module
import url from "@/plugins/urlHelper.js";
import ProImageItem from "./ProductImageItem.vue"; // ES6 Module
export default {
  components: {
    ProImageItem,
    VueUeditorWrap,
  },
  data() {
    return {
      editorConfig: {
        initialFrameHeight: 400, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE(),
      },
      editorConfig2: {
        initialFrameHeight: 200, //设置高度
        initialFrameWidth: "100%", //设置宽度
        UEDITOR_HOME_URL: url.getUEConfig(),
        serverUrl: url.getUE(),
      },
      query: {}, //对象
      loading: false,
      currentPage4: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      form: {}, //表单对象
      dialogVisible: false,
      submiting: false,
      id: 0,
      domain: url.getDomain(),
      domainFront: url.getDomainFront(),
      productID: 0,
      productName: "产品名称",
      dialogImage: false,
      cascaderType: [], // 产品类型-级联
      cascader: [], // 产品类型-级联，回显数据
    };
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage4 = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage4 = val;
      this.getList();
    },
    //图片管理
    openChildDialog: function (row) {
      this.dialogImage = true;
      this.productID = row.id;
      this.productName = row.name;
    },
    //级联事件
    changeCascader: function (value) {
      this.query.typeId = value.toString().split(",")[1];
      this.currentPage4 = 1;
      this.getList();
    },
    //搜索查询
    selList: function () {
      this.currentPage4 = 1;
      this.getList();
    },
    getList: function () {
      var _this = this;
      _this.loading = true;
      var params = _this.query;
      params.pageindex = _this.currentPage4;
      params.pagesize = _this.pageSize;
      var link = url.getProduct("getlist");
      $.get(link, params, (data) => {
        _this.loading = false;
        _this.tableData = data.list;
        _this.total = data.total;
      });
    },
    // 获取产品类型-级联
    getCascaderType: function () {
      var _this = this;
      var link = url.getProductType("GetCascaderType");
      $.get(link, (data) => {
        _this.cascaderType = data;
      });
    },
    //级联事件-编辑
    handleType: function (value) {
      this.$set(this.form, "typeCascader", this.cascader.toString());
      this.currentPage4 = 1;
      this.getList();
    },
    // 提交表单
    submitForm(formName) {
      var _this = this;
      var link = url.getProduct("save");
      var info = this.form;
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.submiting = true;
          //提交后台添加
          $.post(link, info, (res) => {
            _this.submiting = false;
            if (res.status) {
              _this.resetForm("form");
              _this.dialogVisible = false;
              _this.getList();
              _this.$message({
                type: "success",
                message: res.msg,
              });
            } else {
              _this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        } else {
          return false;
        }
      });
    },
    // 添加
    addClick: function () {
      this.dialogVisible = true;
    },
    // 编辑
    editClick: function (row) {
      // this.form = Object.assign({}, row);
      this.dialogVisible = true;
      // 获取并赋值
      var id = row.id;
      var link = url.getProduct("getmodel");
      $.get(link, { id: id }, (res) => {
        this.form = res;
        // 获取级联数据回显
        if (res.typeCascader) {
          this.cascader = res.typeCascader.split(",").map(Number);
        }
      });
    },
    //删除
    delClick: function (row) {
      var _this = this;
      var link = url.getProduct("delete"); //获取请求地址
      var id = row.id; //获取对象id
      this.$confirm("确定要删除？", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          $.post(link, { id: id }, (res) => {
            _this.btnLoading = false;
            if (res.status) {
              _this.msg = res;
              _this.getList();
              this.$message({
                type: "success",
                message: "删除成功!",
              });
            } else {
              this.$message({
                type: "error",
                message: res.msg,
              });
            }
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    //推荐首页
    changeRecommend: function (row) {
      var _this = this;
      var link = url.getProduct("ChangeRecommend"); //获取请求地址
      var id = row.id; //获取对象id
      $.post(link, { id: id }, (res) => {
        _this.btnLoading = false;
        if (res.status) {
          _this.msg = res;
          _this.getList();
          this.$message({
            type: "success",
            message: "修改成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //是否隐藏
    changeHidden: function (row) {
      var _this = this;
      var link = url.getProduct("ChangeHidden"); //获取请求地址
      var id = row.id; //获取对象id
      $.post(link, { id: id }, (res) => {
        _this.btnLoading = false;
        if (res.status) {
          _this.msg = res;
          _this.getList();
          this.$message({
            type: "success",
            message: "修改成功",
          });
        } else {
          this.$message({
            type: "error",
            message: res.msg,
          });
        }
      });
    },
    //是否重复
    checkExist: function (e) {
      var link = url.getProduct("CheckExist"); //获取请求地址
      $.post(link, { key: e.target.value }, (res) => {
        if (res.status) {
          this.$message({
            type: "error",
            message: "标题已存在，请勿重复添加",
          });
        }
      });
    },
    //窗口关闭事件
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then((_) => {
          this.resetForm("form");
          done();
        })
        .catch((_) => {});
    },
    //重置表单/重置校验
    resetForm(formName) {
      //对整个表单进行重置，将所有字段值重置为初始值并移除校验结果
      this.$refs[formName].resetFields(); //prop：在使用 validate、resetFields 方法的情况下，该属性是必填的
      this.cascader = [];
      this.form = {
        typeCascader: "",
      };
    },
  },
  mounted() {
    //获取服务器列表
    this.getList();
    //获取级联产品分类
    this.getCascaderType();
  },
};
</script>
